require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-receives-two-national-awards-from-credit-union-national.json") })
        }
      }, "path---articles-financial-center-receives-two-national-awards-from-credit-union-national");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-receives-two-national-awards-from-credit-union-national!./.cache/json/articles-financial-center-receives-two-national-awards-from-credit-union-national.json
// module id = 1659
// module chunks = 231608221292675